import { a as __spreadArray, _ as __read, b as __generator, c as __assign, d as __awaiter, e as __rest, f as __extends } from './tslib.es6-80f01feb.js';
import axios__default from 'axios';
import { makeObservable, observable, action, flow, computed } from 'mobx';
import { HttpResponse } from './shared/core/classes/httpResponse/index.js';
import { HubConnectionState, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { CommonConnectionsMethod, GameLiveConnectionMethod, ConnectionPrefix, LobbyLiveConnectionMethod } from './shared/core/services/liveConnection/types.js';
import { gameResultStore } from './shared/core/store/gameResultStore.js';
import './shared/core/services/sound/types.js';
import './shared/core/services/sound/SoundService.js';
import './shared/core/services/sound/defaultSounds.js';
import { AuthHeaders } from './shared/core/services/api/types.js';
import './shared/core/enums/GameSpecificTypes.js';
import './shared/core/enums/Chat.js';
import './shared/core/enums/GameModes.js';
import './shared/core/enums/IconTypes.js';
import './shared/core/enums/BetStatus.js';
import './shared/core/enums/PopupTypes.js';
import { ApiVersion } from './shared/core/enums/ApiVersion.js';
import './shared/core/enums/RoundStatus.js';
import { RequestStatus } from './shared/core/enums/RequestStatus.js';
import './shared/core/enums/FreeBetsStatus.js';
import { ChatSocketEvents } from './shared/core/enums/SocketEvents.js';
import './shared/core/enums/TranslationKeys.js';
import { ApiServiceTypes } from './shared/core/enums/ApiServiceTypes.js';
import './shared/core/enums/EnvironmentTypes.js';
import { DefaultQueryParams } from './shared/core/enums/DefaultQueryParams.js';
import { BetHistoryFilterTypes } from './shared/core/enums/BetHistoryFilterTypes.js';
import './shared/core/enums/GameThemeTypes.js';
import { BetsFetchDefaultPaths, BetsFetchDefaultParamNames } from './shared/core/enums/FetchDefaultPaths.js';
import './shared/core/enums/ResponseCodes.js';
import { BaseApiService } from './shared/core/services/api/BaseApiService.js';
import { environmentBuilder } from './shared/core/helpers/environmentBuilder.js';
import { m as moment } from './moment-27179cac.js';
import { lobbyStore } from './shared/core/store/lobbyStore.js';
import { roundInfoStore } from './shared/core/store/roundInfoStore.js';
import './shared/core/store/userCountStore.js';
import { gameConfigStore } from './shared/core/store/gameConfigStore.js';
import { StatisticsSortingTypes } from './shared/core/enums/StatisticsSortingTypes.js';
import { ApiServices } from './shared/core/services/ApiServices.js';
import './shared/core/store/resultHashStore.js';
import './shared/core/store/userWinBetsStore.js';
import './shared/core/store/userSettingsStore.js';
import './shared/core/store/notificationStore.js';
import { parseQuery } from './shared/core/helpers/parseQuery.js';
import { getStartEndDay } from './shared/core/helpers/momentFormat.js';
import './shared/core/store/selectedResultInfoStore.js';
import { chatStore } from './shared/core/store/chatStore.js';
import { PopUps } from './table-line/t_types/enums/PopupTypes.js';
import { parseNumberByPrecision } from './shared/core/helpers/parseNumberByPrecision.js';

var StatisticsStore = /** @class */ (function () {
    function StatisticsStore() {
        this.statistics = {
            100: [],
            200: [],
            500: [],
        };
        this.highestOddsData = [];
        makeObservable(this, {
            statistics: observable.deep,
            highestOddsData: observable.deep,
            setStatistics: action.bound,
            setHighestOddsData: action.bound,
            getHttpStatistics: flow.bound,
            sortStatisticsDataBySortType: action.bound,
        });
    }
    StatisticsStore.prototype.buildStatisticsData = function (statistics) {
        var currentStatisticsData = {};
        var convertObjToArray = function (obj) { var _a; return (_a = Object.keys(obj)) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, curr) { return __spreadArray(__spreadArray([], __read(acc), false), [{ num: curr, count: obj[curr] }], false); }, []); };
        for (var key in statistics) {
            currentStatisticsData[key] = convertObjToArray(statistics[key]);
        }
        return currentStatisticsData;
    };
    StatisticsStore.prototype.setHighestOddsData = function (highestOddsData) {
        this.highestOddsData = highestOddsData;
    };
    StatisticsStore.prototype.getHttpStatistics = function () {
        var gameTypeId, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    gameTypeId = gameConfigStore.gameTypeId;
                    return [4 /*yield*/, ApiServices.get(ApiServiceTypes.StatisticsService).getStatistics({ gameTypeId: gameTypeId })];
                case 1:
                    result = (_a.sent()).data.result;
                    (result === null || result === void 0 ? void 0 : result.statistics) && this.setStatistics(this.buildStatisticsData(result === null || result === void 0 ? void 0 : result.statistics));
                    (result === null || result === void 0 ? void 0 : result.highestOdds) && this.setHighestOddsData(result === null || result === void 0 ? void 0 : result.highestOdds);
                    return [2 /*return*/];
            }
        });
    };
    StatisticsStore.prototype.setStatistics = function (statistics) {
        this.statistics = statistics;
    };
    StatisticsStore.prototype.sortStatisticsDataBySortType = function (sortType, lastRoundValue) {
        var _a, _b, _c;
        var Default = StatisticsSortingTypes.Default, Ascending = StatisticsSortingTypes.Ascending, Descending = StatisticsSortingTypes.Descending;
        var sortDataByType = (_a = {},
            _a[Default] = this.statistics,
            _a[Ascending] = __assign(__assign({}, this.statistics), (_b = {}, _b[lastRoundValue] = this.statistics[lastRoundValue].slice().sort(function (a, b) { return a.count - b.count; }), _b)),
            _a[Descending] = __assign(__assign({}, this.statistics), (_c = {}, _c[lastRoundValue] = this.statistics[lastRoundValue].slice().sort(function (a, b) { return b.count - a.count; }), _c)),
            _a);
        return __assign({}, sortDataByType[sortType]);
    };
    return StatisticsStore;
}());
var statisticsStore = new StatisticsStore();

var PopupStore = /** @class */ (function () {
    function PopupStore() {
        this.popupName = null;
        this.popupToggle = false;
        this.currentData = null;
        this.underMaintenance = false;
        this.maxWinToastState = false;
        this.reloadFrameForUnderMaintenance = false;
        this.underMaintenanceSeconds = null;
        this.reconnect = false;
        this.connectionError = false;
        this.slowConnection = false;
        this.isFromBetHistory = false;
        this.isFromHighestRounds = false;
        this.hashResult = null;
        this.demoBetsCount = 0;
        // for mobile lobby page condition, game types or topWinners
        this.isGameTypesSectionActive = true;
        makeObservable(this, {
            popupName: observable,
            popupToggle: observable,
            currentData: observable,
            underMaintenance: observable,
            maxWinToastState: observable,
            reloadFrameForUnderMaintenance: observable,
            underMaintenanceSeconds: observable,
            reconnect: observable,
            connectionError: observable,
            slowConnection: observable,
            isFromBetHistory: observable,
            hashResult: observable,
            isGameTypesSectionActive: observable,
            demoBetsCount: observable,
            open: action.bound,
            close: action.bound,
            detectAndOpenCheckHashPopup: action.bound,
            onUnderMaintenanceCountdown: action.bound,
            toggleUnderMaintenance: action.bound,
            toggleReconnect: action.bound,
            onConnectionError: action.bound,
            toggleSlowConnection: action.bound,
            reloadFrameForUnderMaintenanceToggle: action.bound,
            maxWinToggle: action.bound,
            setHashResult: action.bound,
            getHashResult: action.bound,
            setIsGameTypesSectionActive: action.bound,
            setDemoBetsCount: action.bound,
            updateDemoBetsCount: action.bound,
        });
    }
    PopupStore.prototype.setDemoBetsCount = function (count) {
        this.demoBetsCount = count;
    };
    PopupStore.prototype.updateDemoBetsCount = function () {
        this.demoBetsCount += 1;
    };
    PopupStore.prototype.open = function (_a) {
        var _b = _a.data, data = _b === void 0 ? null : _b, _c = _a.name, name = _c === void 0 ? null : _c, _d = _a.isFromBetHistory, isFromBetHistory = _d === void 0 ? false : _d, _e = _a.isFromHighestRounds, isFromHighestRounds = _e === void 0 ? false : _e;
        this.popupToggle = true;
        this.currentData = data;
        this.popupName = name;
        this.isFromBetHistory = isFromBetHistory;
        this.isFromHighestRounds = isFromHighestRounds;
    };
    PopupStore.prototype.close = function (e) {
        if (e === void 0) { e = null; }
        e && e.stopPropagation();
        this.popupToggle = false;
        this.currentData = null;
        this.popupName = null;
    };
    PopupStore.prototype.startUnderMaintenanceFunctional = function (_a) {
        var _this = this;
        var startDate = _a.startDate, notifySeconds = _a.notifySeconds;
        if (startDate) {
            var seconds_1 = Math.floor((+new Date("".concat(startDate).concat(startDate.includes('Z') ? '' : 'Z')) - +new Date()) / 1000);
            if (!notifySeconds || (notifySeconds > seconds_1 && seconds_1 >= 0)) {
                this.toggleUnderMaintenance(true);
                this.onUnderMaintenanceCountdown(seconds_1);
            }
            var interval_1 = setInterval(function () {
                if (seconds_1 >= 0) {
                    if (notifySeconds === seconds_1) {
                        _this.toggleUnderMaintenance(true);
                    }
                    if (!notifySeconds || notifySeconds >= seconds_1) {
                        _this.onUnderMaintenanceCountdown(seconds_1);
                    }
                    seconds_1 -= 1;
                }
                else {
                    clearInterval(interval_1);
                    _this.reloadFrameForUnderMaintenanceToggle(true);
                }
            }, 1000);
        }
    };
    PopupStore.prototype.onUnderMaintenanceCountdown = function (seconds) {
        this.underMaintenanceSeconds = seconds;
    };
    PopupStore.prototype.toggleUnderMaintenance = function (state) {
        if (state !== undefined) {
            this.underMaintenance = state;
        }
        else {
            this.underMaintenance = !this.underMaintenance;
        }
    };
    PopupStore.prototype.toggleReconnect = function (state) {
        if (state !== undefined) {
            this.reconnect = state;
        }
        else {
            this.reconnect = !this.reconnect;
        }
    };
    PopupStore.prototype.onConnectionError = function (state) {
        this.connectionError = state;
    };
    PopupStore.prototype.toggleSlowConnection = function (state) {
        if (state !== undefined) {
            this.slowConnection = state;
        }
        else {
            this.slowConnection = !this.slowConnection;
        }
    };
    PopupStore.prototype.reloadFrameForUnderMaintenanceToggle = function (state) {
        if (state !== undefined) {
            this.reloadFrameForUnderMaintenance = state;
        }
        else {
            this.reloadFrameForUnderMaintenance = !this.reloadFrameForUnderMaintenance;
        }
    };
    PopupStore.prototype.maxWinToggle = function (state) {
        if (state !== undefined) {
            this.maxWinToastState = state;
        }
        else {
            this.maxWinToastState = !this.maxWinToastState;
        }
    };
    PopupStore.prototype.detectAndOpenCheckHashPopup = function (_a) {
        var selectedId = _a.selectedId, name = _a.name, _b = _a.isFromBetHistory, isFromBetHistory = _b === void 0 ? false : _b, _c = _a.isFromHighestRounds, isFromHighestRounds = _c === void 0 ? false : _c;
        var data;
        if (isFromBetHistory) {
            var betHistoryData = betStore.betHistory.data;
            data = betHistoryData.find(function (_a) {
                var id = _a.id;
                return id === selectedId;
            });
        }
        else {
            var gameResults = gameResultStore.gameResults;
            var highestOddsData = statisticsStore.highestOddsData;
            data = (isFromHighestRounds ? highestOddsData : gameResults).find(function (_a) {
                var roundId = _a.roundId;
                return roundId === selectedId;
            });
            if (isFromHighestRounds) {
                data = data.roundData;
            }
        }
        this.open({ data: data, name: name, isFromBetHistory: isFromBetHistory, isFromHighestRounds: isFromHighestRounds });
    };
    PopupStore.prototype.getHashResult = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var fetchedData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiServices.get(ApiServiceTypes.RoundsService).checkResultHash(data)];
                    case 1:
                        fetchedData = _a.sent();
                        if (fetchedData && fetchedData.data.result) {
                            this.setHashResult(fetchedData.data.result);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PopupStore.prototype.setHashResult = function (hashResult) {
        if (hashResult === void 0) { hashResult = null; }
        this.hashResult = hashResult;
    };
    PopupStore.prototype.setIsGameTypesSectionActive = function (state) {
        if (state !== undefined) {
            this.isGameTypesSectionActive = state;
        }
        else {
            this.isGameTypesSectionActive = !this.isGameTypesSectionActive;
        }
    };
    return PopupStore;
}());
var popupStore = new PopupStore();

var ApplicationStore = /** @class */ (function () {
    function ApplicationStore() {
        this.isDemo = false;
        this.accessToken = '';
        this.isGuest = false;
        this.isBogLine = false;
        this.gameIsOpen = false;
        this.isTestPlatform = false;
        this.isISOStandard = false;
        this.isAuthenticated = false;
        this.isAuthDataReceived = false;
        this.alreadyRedirectedToGame = false;
        makeObservable(this, {
            isDemo: observable,
            isGuest: observable,
            gameIsOpen: observable,
            isTestPlatform: observable,
            isISOStandard: observable,
            accessToken: observable,
            isAuthenticated: observable,
            isAuthDataReceived: observable,
            isBogLine: observable,
            setIsDemo: action.bound,
            setIsGuest: action.bound,
            setGameIsOpen: action.bound,
            checkGameIsOpen: action.bound,
            setIsTestPlatform: action.bound,
            setIsISOStandard: action.bound,
            setAccessToken: action.bound,
            setIsAuthenticated: action.bound,
            setIsAuthDataReceived: action.bound,
            setIsBogLine: action.bound,
            setAlreadyRedirectedToGame: action.bound,
        });
    }
    ApplicationStore.prototype.setIsDemo = function (isDemo) {
        this.isDemo = isDemo;
    };
    ApplicationStore.prototype.setGameIsOpen = function (gameIsOpen) {
        this.gameIsOpen = gameIsOpen;
    };
    ApplicationStore.prototype.setIsTestPlatform = function (isTestPlatform) {
        this.isTestPlatform = isTestPlatform;
    };
    ApplicationStore.prototype.checkGameIsOpen = function (data, connection) {
        var gameTypeId = gameConfigStore.gameTypeId, gameId = gameConfigStore.gameId;
        if (connection &&
            connection.connectionId !== data.connectionId &&
            (data.gameId === +gameId || data.gameTypeId === +gameTypeId)) {
            this.setGameIsOpen(true);
            if (!this.isBogLine) {
                popupStore.open({ name: PopUps.GameOpen });
            }
            connection.stop();
        }
    };
    ApplicationStore.prototype.setIsGuest = function (isGuest) {
        this.isGuest = isGuest;
    };
    ApplicationStore.prototype.setIsISOStandard = function (isISOStandard) {
        this.isISOStandard = isISOStandard;
    };
    ApplicationStore.prototype.demoSwitcher = function (demoSwitcherAdditionalFunction) {
        var isAuthenticated = applicationStore.isAuthenticated;
        if (isAuthenticated) {
            applicationStore.setIsDemo(false);
            if (popupStore.demoBetsCount) {
                popupStore.setDemoBetsCount(0);
            }
            if (demoSwitcherAdditionalFunction) {
                demoSwitcherAdditionalFunction();
            }
        }
        else {
            iframeService.sendPgLogin();
        }
    };
    ApplicationStore.prototype.setAccessToken = function (accessToken) {
        this.accessToken = accessToken;
    };
    ApplicationStore.prototype.setIsAuthenticated = function (isAuthenticated) {
        this.isAuthenticated = isAuthenticated;
    };
    ApplicationStore.prototype.setIsAuthDataReceived = function (isAuthDataReceived) {
        this.isAuthDataReceived = isAuthDataReceived;
    };
    ApplicationStore.prototype.setIsBogLine = function (isBogLine) {
        this.isBogLine = isBogLine;
    };
    ApplicationStore.prototype.setAlreadyRedirectedToGame = function (value) {
        this.alreadyRedirectedToGame = value;
    };
    return ApplicationStore;
}());
var applicationStore = new ApplicationStore();

var BetsStore = /** @class */ (function () {
    function BetsStore() {
        this.liveBets = []; // GAME BETS
        this.currentWinners = []; // LOBBY BETS
        this._betHistory = new HttpResponse([]);
        this._demoBetHistory = [];
        this.betHistoryTotalCount = 0;
        this.topWinners = new HttpResponse([]);
        this.topWinnersTotalCount = 0;
        this.betHistoryFilter = BetHistoryFilterTypes.All;
        this.topWinnersDefaultTake = 20;
        this.betsDefaultTake = 20;
        this.currentWinnersTimeOutId = null;
        makeObservable(this, {
            betHistory: computed,
            topWinners: observable.deep,
            _betHistory: observable.deep,
            _demoBetHistory: observable.deep,
            betHistoryFilter: observable,
            currentWinners: observable,
            liveBets: observable.deep,
            setTopWinners: action.bound,
            setDemoBetHistory: action.bound,
            updateDemoBetHistory: action.bound,
            setBetHistory: action.bound,
            setBetHistoryFilter: action.bound,
            setCurrentWinners: action.bound,
            updateCurrentWinners: action.bound,
            resetBetHistory: action.bound,
            resetTopWinners: action.bound,
            setLiveBets: action.bound,
            updateLiveBets: action.bound,
            spliceLiveBets: action.bound,
            getTopWinners: flow.bound,
            getBetHistory: flow.bound,
        });
    }
    Object.defineProperty(BetsStore.prototype, "betsService", {
        get: function () {
            return ApiServices.get(ApiServiceTypes.BetsService);
        },
        enumerable: false,
        configurable: true
    });
    BetsStore.prototype.getTopWinners = function (params) {
        var _a, skip, _b, take, _c, fetchPath;
        var _this = this;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_d) {
            _a = params.skip, skip = _a === void 0 ? this.topWinners.data.length : _a, _b = params.take, take = _b === void 0 ? this.topWinnersDefaultTake : _b, _c = params.fetchPath, fetchPath = _c === void 0 ? BetsFetchDefaultPaths.TopWinners : _c;
            if (!this.topWinnersTotalCount ||
                !this.topWinners.data.length ||
                (this.topWinners.data.length + 1 < this.topWinnersTotalCount && this.topWinners.status !== RequestStatus.Pending)) {
                this.fetchingTopWinners();
                this.betsService
                    .getBets({ skip: skip, take: take }, fetchPath)
                    .then(function (_a) {
                    var _b = _a.data.result, items = _b.items, count = _b.count;
                    _this.topWinnersTotalCount = count;
                    _this.fetchedTopWinners(items);
                })
                    .catch(function (error) {
                    _this.setTopWinners(_this.topWinners.failed(error));
                });
            }
            return [2 /*return*/];
        });
    };
    BetsStore.prototype.setTopWinners = function (topWinners) {
        this.topWinners = topWinners;
    };
    BetsStore.prototype.getBetHistory = function (params) {
        var _a, skip, _b, take;
        var _this = this;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            _a = params.skip, skip = _a === void 0 ? this._betHistory.data.length : _a, _b = params.take, take = _b === void 0 ? this.betsDefaultTake : _b;
            if (!this.betHistoryTotalCount ||
                !this._betHistory.data.length ||
                (this._betHistory.data.length + 1 < this.betHistoryTotalCount &&
                    this._betHistory.status !== RequestStatus.Pending)) {
                this.fetchingBetHistory();
                this.betsService
                    .getBets({
                    skip: skip,
                    take: take,
                    status: this.betHistoryFilter === BetHistoryFilterTypes.All ? null : this.betHistoryFilter,
                })
                    .then(function (_a) {
                    var _b = _a.data.result, items = _b.items, count = _b.count;
                    _this.betHistoryTotalCount = count;
                    _this.fetchedBetHistory(items);
                })
                    .catch(function (error) {
                    _this.setBetHistory(_this._betHistory.failed(error));
                });
            }
            return [2 /*return*/];
        });
    };
    BetsStore.prototype.setBetHistory = function (bets) {
        this._betHistory = bets;
    };
    BetsStore.prototype.setDemoBetHistory = function (bets) {
        this._demoBetHistory = bets;
    };
    BetsStore.prototype.updateDemoBetHistory = function (bets) {
        this._demoBetHistory = __spreadArray(__spreadArray([], __read(bets), false), __read(this._demoBetHistory), false);
    };
    BetsStore.prototype.setCurrentWinners = function (currentWinners) {
        if (this.currentWinnersTimeOutId) {
            clearTimeout(this.currentWinnersTimeOutId);
        }
        this.currentWinners = currentWinners;
    };
    BetsStore.prototype.updateCurrentWinnersWithDelay = function (currentWinners) {
        var _this = this;
        this.currentWinnersTimeOutId = setTimeout(function () {
            _this.updateCurrentWinners(currentWinners);
        }, roundInfoStore.roundFinAnimationDuration);
    };
    BetsStore.prototype.updateCurrentWinners = function (currentWinners) {
        this.currentWinners = __spreadArray(__spreadArray([], __read(currentWinners), false), __read(this.currentWinners), false);
    };
    BetsStore.prototype.setLiveBets = function (liveBets) {
        this.liveBets = liveBets;
    };
    BetsStore.prototype.updateLiveBets = function (liveBet) {
        this.liveBets = __spreadArray(__spreadArray([], __read(this.liveBets), false), [liveBet], false);
    };
    BetsStore.prototype.spliceLiveBets = function (from, to) {
        this.liveBets.splice(from, to);
    };
    BetsStore.prototype.setBetHistoryFilter = function (filter) {
        this.betHistoryFilter = filter;
        this.resetBetHistory();
        this.getBetHistory();
    };
    BetsStore.prototype.fetchingBetHistory = function () {
        this.setBetHistory(this._betHistory.fetching());
    };
    BetsStore.prototype.fetchedBetHistory = function (response) {
        this.setBetHistory(this._betHistory.fetched(__spreadArray(__spreadArray([], __read(this._betHistory.data), false), __read(response), false)));
    };
    BetsStore.prototype.fetchingTopWinners = function () {
        this.setTopWinners(this.topWinners.fetching());
    };
    BetsStore.prototype.fetchedTopWinners = function (response) {
        this.setTopWinners(this.topWinners.fetched(__spreadArray(__spreadArray([], __read(this.topWinners.data), false), __read(response), false)));
    };
    BetsStore.prototype.resetTopWinners = function () {
        this.setTopWinners(this.topWinners.fetching(true));
    };
    BetsStore.prototype.resetBetHistory = function () {
        this.setBetHistory(this._betHistory.fetching(true));
    };
    Object.defineProperty(BetsStore.prototype, "betHistory", {
        get: function () {
            var isDemo = applicationStore.isDemo;
            // need to improve
            return isDemo ? { data: this._demoBetHistory } : this._betHistory;
        },
        enumerable: false,
        configurable: true
    });
    return BetsStore;
}());
var betStore = new BetsStore();

var UserInfoStore = /** @class */ (function () {
    function UserInfoStore() {
        this.rate = '';
        this.precision = '';
        this.playerExternalId = '';
        this.userId = '';
        this._currencyCode = '';
        this._demoCurrencyCode = 'Fun';
        this._currencySymbol = '';
        this._balance = 0;
        this._demoInitialBalance = 500000;
        this._demoBalance = this._demoInitialBalance;
        makeObservable(this, {
            rate: observable,
            precision: observable,
            currencyCode: computed,
            currencySymbolOrCode: computed,
            realCurrencySymbolOrCode: computed,
            balance: computed,
            playerExternalId: observable,
            userId: observable,
            _demoBalance: observable,
            _balance: observable,
            _demoCurrencyCode: observable,
            _currencyCode: observable,
            setUserInfo: action.bound,
            setRate: action.bound,
            setUserId: action.bound,
            setPrecision: action.bound,
            setCurrencyCode: action.bound,
            setCurrencySymbol: action.bound,
            setBalance: action.bound,
            setDemoBalance: action.bound,
            setPlayerExternalId: action.bound,
            setDemoInitialBalance: action.bound,
        });
    }
    UserInfoStore.prototype.setUserInfo = function (userInfo) {
        var rate = userInfo.rate, precision = userInfo.precision, currencyCode = userInfo.currencyCode, currencySymbol = userInfo.currencySymbol, balance = userInfo.balance, playerExternalId = userInfo.playerExternalId, demoBalance = userInfo.demoBalance, userId = userInfo.userId;
        this.setRate(rate);
        this.setPrecision(precision);
        this.setCurrencyCode(currencyCode);
        this.setCurrencySymbol(currencySymbol);
        this.setBalance(balance);
        this.setPlayerExternalId(playerExternalId);
        this.setUserId(userId);
        if (demoBalance) {
            this.setDemoBalance(demoBalance);
        }
    };
    UserInfoStore.prototype.setRate = function (rate) {
        this.rate = rate;
    };
    UserInfoStore.prototype.setUserId = function (userId) {
        if (userId) {
            this.userId = userId;
        }
        else {
            var _a = parseQuery(window.location.search), _b = DefaultQueryParams.UserId, userIdFromQuery = _a[_b];
            this.userId = userIdFromQuery;
        }
    };
    UserInfoStore.prototype.setPrecision = function (precision) {
        this.precision = precision;
    };
    UserInfoStore.prototype.setCurrencyCode = function (currencyCode) {
        this._currencyCode = currencyCode;
    };
    UserInfoStore.prototype.setCurrencySymbol = function (currencySymbol) {
        if (currencySymbol) {
            this._currencySymbol = currencySymbol;
        }
        else {
            var _a = parseQuery(window.location.search), _b = DefaultQueryParams.CurrencySymbol, currencySymbolFromQuery = _a[_b];
            this._currencySymbol = currencySymbolFromQuery;
        }
    };
    UserInfoStore.prototype.setBalance = function (balance) {
        this._balance = balance;
    };
    UserInfoStore.prototype.setPlayerExternalId = function (playerExternalId) {
        if (playerExternalId) {
            this.playerExternalId = playerExternalId;
        }
        else {
            var _a = parseQuery(window.location.search), _b = DefaultQueryParams.PlayerExternalId, playerExternalIdFromQuery = _a[_b];
            this.playerExternalId = playerExternalIdFromQuery;
        }
    };
    UserInfoStore.prototype.setDemoInitialBalance = function () {
        this._demoBalance = this._demoInitialBalance;
    };
    UserInfoStore.prototype.setDemoBalance = function (demoBalance) {
        this._demoBalance = parseNumberByPrecision(demoBalance, 1);
    };
    Object.defineProperty(UserInfoStore.prototype, "balance", {
        get: function () {
            var isDemo = applicationStore.isDemo;
            return isDemo ? this._demoBalance : this._balance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "currencyCode", {
        get: function () {
            var isDemo = applicationStore.isDemo;
            return isDemo ? this._demoCurrencyCode : this._currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "currencySymbolOrCode", {
        get: function () {
            var isDemo = applicationStore.isDemo;
            return isDemo ? this._demoCurrencyCode : this._currencySymbol || this.currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "realCurrencySymbolOrCode", {
        get: function () {
            return this._currencySymbol || this._currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    return UserInfoStore;
}());
var userInfoStore = new UserInfoStore();

var TableBetHistoryStore = /** @class */ (function () {
    function TableBetHistoryStore() {
        this.fetchPaths = BetsFetchDefaultPaths;
        this.fetchParamNames = BetsFetchDefaultParamNames;
        this.queryState = {
            skip: 0,
            take: 15,
        };
        this.selectedHistoryRow = null;
        this.showRoundBet = false;
        this.firstStep = {
            data: {
                items: [],
                count: 0,
            },
            pending: false,
        };
        this.thirdStep = {
            data: {},
            pending: false,
        };
        this.secondStep = {
            data: {},
            pending: false,
        };
        makeObservable(this, {
            queryState: observable,
            selectedHistoryRow: observable.deep,
            firstStep: observable.deep,
            thirdStep: observable.deep,
            secondStep: observable.deep,
            fetchPaths: observable.deep,
            fetchParamNames: observable.deep,
            showRoundBet: observable,
            getFirstStep: flow.bound,
            getSecondStep: flow.bound,
            getThirdStep: flow.bound,
            removeThirdStep: action.bound,
            setSelectedHistoryRow: action.bound,
            setFirstStepPending: action.bound,
            setSecondStepPending: action.bound,
            setThirdStepPending: action.bound,
            setFetchPaths: action.bound,
            setFetchParamNames: action.bound,
            betsService: computed,
        });
    }
    Object.defineProperty(TableBetHistoryStore.prototype, "betsService", {
        get: function () {
            return ApiServices.get(ApiServiceTypes.BetsService);
        },
        enumerable: false,
        configurable: true
    });
    TableBetHistoryStore.prototype.setSelectedHistoryRow = function (payload) {
        this.selectedHistoryRow = payload;
    };
    TableBetHistoryStore.prototype.setShowRoundBet = function (arg) {
        this.showRoundBet = arg;
    };
    TableBetHistoryStore.prototype.setFirstStepPending = function () {
        this.firstStep.pending = !this.firstStep.pending;
    };
    TableBetHistoryStore.prototype.handleBetHistoryUpdate = function () {
        var getDay = getStartEndDay(moment().format());
        this.getFirstStep(this.queryState);
        this.getSecondStep({
            key: moment(getDay.startDate).format('YYYY-MM-DDT00:00:00'),
            date: getDay,
        });
    };
    TableBetHistoryStore.prototype.getFirstStep = function (payload) {
        var _a, _b, gameId, concat, options, result, items, all, firstStep, _c, firstData, firstStepData;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _a = parseQuery(window.location.search), _b = DefaultQueryParams.GameId, gameId = _a[_b];
                    concat = payload.concat, options = __rest(payload, ["concat"]);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    this.setFirstStepPending();
                    return [4 /*yield*/, this.betsService.getBets(__assign({ gameId: gameId }, options), this.fetchPaths.FirstStep)];
                case 2:
                    result = (_e.sent()).data.result;
                    items = result.items, all = __rest(result, ["items"]);
                    firstStep = __assign(__assign({}, all), { items: __spreadArray([], __read(items.sort(function (a, b) { return +moment(b.date) - +moment(a.date); })), false) });
                    if (firstStep.items.length && !((_d = Object.keys(this.secondStep.data)) === null || _d === void 0 ? void 0 : _d.length)) {
                        _c = __read(firstStep.items, 1), firstData = _c[0];
                        this.getSecondStep({ key: firstData.date, date: getStartEndDay(firstData.date) });
                    }
                    if (concat) {
                        firstStepData = this.firstStep.data;
                        this.firstStep = {
                            data: {
                                items: __spreadArray(__spreadArray([], __read(firstStepData.items), false), __read(firstStep.items), false).sort(function (a, b) { return +moment(b.date) - +moment(a.date); }),
                                count: firstStep.count,
                            },
                            pending: false,
                        };
                    }
                    else {
                        this.firstStep = {
                            data: firstStep,
                            pending: false,
                        };
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _e.sent();
                    this.setFirstStepPending();
                    iframeService.reloadFrame();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    };
    TableBetHistoryStore.prototype.setSecondStepPending = function () {
        this.secondStep.pending = !this.secondStep.pending;
    };
    TableBetHistoryStore.prototype.getSecondStep = function (payload) {
        var _a, _b, gameId, key, date, result;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = parseQuery(window.location.search), _b = DefaultQueryParams.GameId, gameId = _a[_b];
                    key = payload.key, date = payload.date;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    this.setSecondStepPending();
                    return [4 /*yield*/, this.betsService.getBets(__assign({ gameId: gameId }, date), this.fetchPaths.SecondStep)];
                case 2:
                    result = (_d.sent()).data.result;
                    this.secondStep = {
                        data: __assign(__assign({}, this.secondStep.data), (_c = {}, _c[key] = result.items, _c)),
                        pending: false,
                    };
                    return [3 /*break*/, 4];
                case 3:
                    _d.sent();
                    this.setSecondStepPending();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    };
    TableBetHistoryStore.prototype.setThirdStepPending = function () {
        this.thirdStep.pending = !this.thirdStep.pending;
    };
    TableBetHistoryStore.prototype.getThirdStep = function (option) {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    this.setThirdStepPending();
                    return [4 /*yield*/, this.betsService.getBets(option, this.fetchPaths.ThirdStep)];
                case 1:
                    result = (_a.sent()).data.result;
                    this.thirdStep = {
                        data: result.items[0],
                        pending: false,
                    };
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    this.setThirdStepPending();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    };
    TableBetHistoryStore.prototype.removeThirdStep = function () {
        this.thirdStep = {
            data: {},
            pending: false,
        };
    };
    TableBetHistoryStore.prototype.setFetchPaths = function (fetchPaths) {
        this.fetchPaths = __assign(__assign({}, this.fetchPaths), fetchPaths);
    };
    TableBetHistoryStore.prototype.setFetchParamNames = function (fetchParamNames) {
        this.fetchParamNames = __assign(__assign({}, this.fetchParamNames), fetchParamNames);
    };
    return TableBetHistoryStore;
}());
var tableBetHistoryStore = new TableBetHistoryStore();

var ProfileAvatarStore = /** @class */ (function () {
    function ProfileAvatarStore() {
        this.isMobileAvatarsBlockOpened = false;
        this.availableAvatarsType = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
        this.avatarId = this.availableAvatarsType[0];
        this.initialAvatarId = null;
        makeObservable(this, {
            avatarId: observable,
            initialAvatarId: observable,
            updateInitialAvatarId: action.bound,
            isMobileAvatarsBlockOpened: observable,
            updateAvatarId: action.bound,
            sendAvatarIdToBackend: action.bound,
        });
    }
    ProfileAvatarStore.prototype.updateAvatarId = function (id) {
        this.avatarId = id;
    };
    ProfileAvatarStore.prototype.updateInitialAvatarId = function (initialAvatarId) {
        this.initialAvatarId = initialAvatarId;
    };
    ProfileAvatarStore.prototype.sendAvatarIdToBackend = function (userId) {
        var _this = this;
        var gameTypeId = gameConfigStore.gameTypeId;
        ApiServices.get(ApiServiceTypes.UsersService)
            .updateUserAvatar(this.avatarId)
            .then(function () {
            var chatMessageData = chatStore.chatMessageData;
            var updatedChatMessageData = chatMessageData === null || chatMessageData === void 0 ? void 0 : chatMessageData.map(function (item) {
                if ((item === null || item === void 0 ? void 0 : item.userId) === userId) {
                    return __assign(__assign({}, item), { avatarId: _this.avatarId });
                }
                return item;
            });
            chatService.updateAdditionalData(+gameTypeId, _this.avatarId);
            chatStore.setChatMessageHistory(updatedChatMessageData);
        })
            .catch(function (error) {
            console.error(error);
        });
    };
    return ProfileAvatarStore;
}());
var profileAvatarStore = new ProfileAvatarStore();

var RoundsService = /** @class */ (function (_super) {
    __extends(RoundsService, _super);
    function RoundsService(config) {
        return _super.call(this, config) || this;
    }
    RoundsService.prototype.checkResultHash = function (body, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        var version = options.version;
        var url = "".concat(this.url, "/api/").concat(version, "/Rounds/checkResultHash");
        return httpClient.post(url, body);
    };
    RoundsService.prototype.getGameHighestRounds = function (options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        var version = options.version;
        var url = "".concat(this.url, "/api/").concat(version, "/Rounds/getHighestRounds");
        return httpClient.get(url);
    };
    return RoundsService;
}(BaseApiService));

var BetsService = /** @class */ (function (_super) {
    __extends(BetsService, _super);
    function BetsService(config) {
        return _super.call(this, config) || this;
    }
    BetsService.prototype.getBets = function (params, additionalPath, options) {
        if (additionalPath === void 0) { additionalPath = ''; }
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Bets").concat(additionalPath);
                return [2 /*return*/, httpClient.get(url, {
                        params: params,
                    })];
            });
        });
    };
    return BetsService;
}(BaseApiService));

var StatisticsService = /** @class */ (function (_super) {
    __extends(StatisticsService, _super);
    function StatisticsService(config) {
        return _super.call(this, config) || this;
    }
    StatisticsService.prototype.getStatistics = function (params, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Statistics");
                return [2 /*return*/, httpClient.get(url, {
                        params: params,
                    })];
            });
        });
    };
    return StatisticsService;
}(BaseApiService));

var UsersService = /** @class */ (function (_super) {
    __extends(UsersService, _super);
    function UsersService(config) {
        return _super.call(this, config) || this;
    }
    UsersService.prototype.getBalance = function (options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Users/balance");
                return [2 /*return*/, httpClient.get(url)];
            });
        });
    };
    UsersService.prototype.updateUserAvatar = function (avatarId, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Users/updateAvatar");
                return [2 /*return*/, httpClient.put(url, { avatarId: avatarId })];
            });
        });
    };
    return UsersService;
}(BaseApiService));

var ChatService = /** @class */ (function () {
    function ChatService() {
        this.socket = null;
    }
    ChatService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chatSocketUrl, _a, chatConfig, _b, quickWords, typingNotAllowed, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(!this.socket || (this.socket && this.socket.state !== HubConnectionState.Connected))) return [3 /*break*/, 6];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        chatSocketUrl = environmentBuilder().chatSocketUrl;
                        _a = this;
                        return [4 /*yield*/, new BaseLiveConnection(chatSocketUrl).init()];
                    case 2:
                        _a.socket = _c.sent();
                        return [4 /*yield*/, this.getChatConfigs()];
                    case 3:
                        chatConfig = _c.sent();
                        _b = chatConfig.data.data, quickWords = _b.quickWords, typingNotAllowed = _b.typingNotAllowed;
                        chatStore.setQuickWords(quickWords);
                        chatStore.setIsTypingNotAllowed(typingNotAllowed); // typingNotAllowed - if false can type
                        this.invokeInitialSocketEvents();
                        this.socketEventsListeners();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _c.sent();
                        console.log(e_1, 'Chat service failed to connect');
                        chatStore.setIsShowChat(false);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        if (this.socket && this.socket.state === HubConnectionState.Connected) {
                            this.invokeInitialSocketEvents();
                        }
                        _c.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ChatService.prototype.getChatConfiguration = function (params, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var chatHttpUrl, version, url;
            return __generator(this, function (_a) {
                chatHttpUrl = environmentBuilder().chatHttpUrl;
                version = options.version;
                url = "".concat(chatHttpUrl, "/api/").concat(version, "/Chat/Configuration");
                return [2 /*return*/, httpClient.get(url, {
                        params: params,
                    })];
            });
        });
    };
    ChatService.prototype.invokeInitialSocketEvents = function () {
        this.joinRoom();
        this.getChatHistory();
    };
    ChatService.prototype.socketEventsListeners = function () {
        this.socket.on(ChatSocketEvents.GetChatHistoryResult, chatStore.setChatMessageHistory);
        this.socket.on(ChatSocketEvents.ReceiveMessage, this.getMessage);
    };
    ChatService.prototype.joinRoom = function () {
        var gameTypeId = gameConfigStore.gameTypeId;
        this.socket.invoke(ChatSocketEvents.JoinRoom, +gameTypeId);
    };
    ChatService.prototype.getChatHistory = function () {
        var gameTypeId = gameConfigStore.gameTypeId;
        this.socket.invoke(ChatSocketEvents.GetChatHistory, +gameTypeId);
    };
    ChatService.prototype.leaveRoom = function () {
        var gameTypeId = gameConfigStore.gameTypeId;
        this.socket.invoke(ChatSocketEvents.LeaveRoom, +gameTypeId);
    };
    ChatService.prototype.getMessage = function (receivedMessageData) {
        var unReadCount = chatStore.unReadCount;
        if (receivedMessageData) {
            chatStore.updateChatMessageData(receivedMessageData);
            chatStore.updateUnReadCount(unReadCount + 1);
        }
    };
    ChatService.prototype.updateAdditionalData = function (gameTypeId, additionalData) {
        this.socket.invoke(ChatSocketEvents.UpdateAdditionalData, { additionalData: additionalData, gameTypeId: gameTypeId });
    };
    ChatService.prototype.sendMessage = function (data) {
        this.socket.invoke(ChatSocketEvents.SendMessage, data);
    };
    ChatService.prototype.getChatConfigs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var gameId;
            return __generator(this, function (_a) {
                gameId = gameConfigStore.gameId;
                return [2 /*return*/, ApiServices.get(ApiServiceTypes.ChatService).getChatConfiguration({ gameId: gameId })];
            });
        });
    };
    ChatService.prototype.closeConnection = function () {
        if (this.socket) {
            this.socket.stop();
        }
    };
    return ChatService;
}());
var chatService = new ChatService();

var interceptorsId = null;
var httpClient = axios__default.create({
    withCredentials: true,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-type': 'application/json',
    },
});
var setHttpClientInterceptors = function () {
    if (interceptorsId || interceptorsId === 0) {
        httpClient.interceptors.request.eject(interceptorsId);
    }
    interceptorsId = httpClient.interceptors.request.use(function (config) {
        var token = applicationStore.accessToken, isAuthDataReceived = applicationStore.isAuthDataReceived;
        var accessToken = isAuthDataReceived && token ? "".concat(AuthHeaders.Bearer, " ").concat(token) : '';
        if (accessToken) {
            config.headers[AuthHeaders.Authorization] = accessToken;
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
};

var PostMessage;
(function (PostMessage) {
    PostMessage["Reload"] = "reload";
    PostMessage["Logout"] = "logout";
    PostMessage["PgGetAuthInfo"] = "pgGetAuthInfo";
    PostMessage["PgGameLoaded"] = "pgGameLoaded";
    PostMessage["PgLogin"] = "pgLogin";
    PostMessage["RedirectLogin"] = "redirectLogin";
    PostMessage["RedirectHome"] = "redirectHome";
    PostMessage["TogglePlayMode"] = "togglePlayMode";
})(PostMessage || (PostMessage = {}));
var PostMessageListenerMessages;
(function (PostMessageListenerMessages) {
    PostMessageListenerMessages["UpdateBalance"] = "updateBalance";
    PostMessageListenerMessages["StopAutoSpins"] = "stopAutospins";
    PostMessageListenerMessages["AuthInfoUpdate"] = "authInfoUpdate";
})(PostMessageListenerMessages || (PostMessageListenerMessages = {}));
var IframeService = /** @class */ (function () {
    function IframeService() {
    }
    IframeService.prototype.sendParentMessage = function (message, targetOrigin, transfer) {
        if (targetOrigin === void 0) { targetOrigin = '*'; }
        window.parent.postMessage(message, targetOrigin, transfer);
    };
    IframeService.prototype.sendTopMessage = function (message, targetOrigin, transfer) {
        if (targetOrigin === void 0) { targetOrigin = '*'; }
        window.top.postMessage(message, targetOrigin, transfer);
    };
    IframeService.prototype.openTab = function (tab) {
        this.sendTopMessage({ action: 'openSlider', tab: tab });
    };
    IframeService.prototype.openDeposit = function () {
        this.openTab('deposit');
    };
    IframeService.prototype.openLogin = function () {
        this.openTab('login');
    };
    IframeService.prototype.reloadFrame = function () {
        this.sendParentMessage(PostMessage.Reload);
    };
    IframeService.prototype.logout = function () {
        this.sendParentMessage(PostMessage.Logout);
    };
    IframeService.prototype.sendLoadedState = function () {
        this.sendParentMessage(PostMessage.PgGameLoaded);
    };
    IframeService.prototype.sendGetAuthInfo = function () {
        this.sendParentMessage(PostMessage.PgGetAuthInfo);
    };
    IframeService.prototype.sendPgLogin = function () {
        this.sendParentMessage(PostMessage.PgLogin);
    };
    IframeService.prototype.redirectLogin = function () {
        this.sendParentMessage(PostMessage.RedirectLogin);
    };
    IframeService.prototype.redirectHome = function () {
        this.sendParentMessage(PostMessage.RedirectHome);
    };
    IframeService.prototype.reloadFrameForRealMoney = function (gameId) {
        this.sendTopMessage({ action: PostMessage.TogglePlayMode, gameId: gameId });
    };
    IframeService.prototype.redirect = function (type) {
        if (type === void 0) { type = false; }
        type ? this.redirectHome() : this.redirectLogin();
    };
    /**
     * @deprecated please use redirect
     */
    IframeService.prototype.redirection = function (type, target) {
        console.warn('redirection method deprecated pls use redirect');
        this.redirect(type);
    };
    IframeService.prototype.isInIframe = function () {
        try {
            return window.self !== window.top;
        }
        catch (e) {
            console.error(e);
            return true;
        }
    };
    IframeService.prototype.setPostMessageListener = function (messageParams) {
        if (!this.isInIframe()) {
            applicationStore.setIsAuthDataReceived(true);
        }
        else {
            window.addEventListener('message', function (message) {
                if (message.data && message.data.name === PostMessageListenerMessages.AuthInfoUpdate) {
                    var _a = message.data, accessToken = _a.accessToken, isAuthenticated = _a.isAuthenticated;
                    applicationStore.setIsAuthenticated(isAuthenticated);
                    applicationStore.setAccessToken(accessToken);
                    applicationStore.setIsAuthDataReceived(true);
                    setHttpClientInterceptors();
                }
                if (messageParams && messageParams.length) {
                    messageParams.forEach(function (_a) {
                        var name = _a.name, callback = _a.callback;
                        if (message.data && message.data.name === name) {
                            callback(message.data);
                        }
                    });
                }
            });
        }
    };
    return IframeService;
}());
var iframeService = new IframeService();

var BaseLiveConnection = /** @class */ (function () {
    function BaseLiveConnection(url) {
        this.isOnReconnectingState = false;
        this.url = url;
    }
    BaseLiveConnection.prototype.waitStarted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.connectionStartPromise instanceof Promise)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connectionStartPromise];
                    case 1:
                        _a.sent();
                        this.connectionStartPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.waitStop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.connectionStopPromise instanceof Promise)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connectionStopPromise];
                    case 1:
                        _a.sent();
                        this.connectionStopPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.init = function (reconnectTimes) {
        var _a;
        if (reconnectTimes === void 0) { reconnectTimes = [300, 600]; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.waitStop()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.waitStarted()];
                    case 2:
                        _b.sent();
                        if (!(((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) !== HubConnectionState.Connected)) return [3 /*break*/, 4];
                        this.connection = this.createConnection(reconnectTimes);
                        this.connectionStartPromise = this.connection.start();
                        return [4 /*yield*/, this.waitStarted()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/, this.connection];
                }
            });
        });
    };
    BaseLiveConnection.prototype.createConnection = function (reconnectTimes) {
        if (reconnectTimes === void 0) { reconnectTimes = [300, 600]; }
        var accessToken = applicationStore.accessToken;
        return new HubConnectionBuilder()
            .withUrl(this.url, { accessTokenFactory: function () { return accessToken; } })
            .configureLogging(LogLevel.Information)
            .withAutomaticReconnect(reconnectTimes)
            .build();
    };
    BaseLiveConnection.prototype.invoke = function (methodName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.waitStarted()];
                    case 1:
                        _b.sent();
                        if (this.connection.state === HubConnectionState.Connected)
                            return [2 /*return*/, (_a = this.connection).invoke.apply(_a, __spreadArray([methodName], __read(args), false))];
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.on = function (methodName, handler) {
        if (this.connection.state === HubConnectionState.Connected)
            this.connection.on(methodName, handler);
        return this;
    };
    BaseLiveConnection.prototype.onReconnecting = function (callback) {
        var _this = this;
        if (this.connection) {
            this.connection.onreconnecting(function (data) {
                if (callback) {
                    callback(data);
                }
                _this.isOnReconnectingState = true;
                _this.callbackMiddleware({
                    methodName: CommonConnectionsMethod.Reconnecting,
                });
            });
        }
    };
    BaseLiveConnection.prototype.onClose = function (callback) {
        var _this = this;
        if (this.connection && this.connection.state === HubConnectionState.Connected) {
            return this.connection.onclose(function (data) {
                if (callback) {
                    callback(data);
                }
                if (_this.isOnReconnectingState) {
                    _this.callbackMiddleware({
                        methodName: CommonConnectionsMethod.ConnectionClose,
                    });
                }
            });
        }
    };
    BaseLiveConnection.prototype.onReconnected = function (callback) {
        var _this = this;
        if (this.connection) {
            return this.connection.onreconnected(function (data) {
                if (callback) {
                    callback(data);
                }
                _this.isOnReconnectingState = false;
                _this.callbackMiddleware({
                    methodName: CommonConnectionsMethod.Reconnected,
                });
            });
        }
    };
    BaseLiveConnection.prototype.stop = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.waitStarted()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.waitStop()];
                    case 2:
                        _b.sent();
                        if (!(((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) === HubConnectionState.Connected)) return [3 /*break*/, 4];
                        this.connectionStopPromise = this.connection.stop().then(function () {
                            _this.connectionStartPromise = null;
                        });
                        return [4 /*yield*/, this.waitStop()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.callbackMiddleware = function (_a) {
        var _b;
        var _this = this;
        var data = _a.data, methodName = _a.methodName;
        var methods = (_b = {},
            _b[CommonConnectionsMethod.UnderMaintenance] = function (arg) { return popupStore.startUnderMaintenanceFunctional(arg); },
            _b[GameLiveConnectionMethod.BalanceUpdate] = function (arg) { return userInfoStore.setBalance(arg); },
            _b[GameLiveConnectionMethod.RoundStarted] = function (arg) {
                var underMaintenance = arg.underMaintenance, statistics = arg.statistics;
                if (statistics === null || statistics === void 0 ? void 0 : statistics.statistics) {
                    var buildStatisticsData = statisticsStore.buildStatisticsData, setStatistics = statisticsStore.setStatistics;
                    setStatistics(buildStatisticsData(statistics === null || statistics === void 0 ? void 0 : statistics.statistics));
                }
                (statistics === null || statistics === void 0 ? void 0 : statistics.highestOdds) && statisticsStore.setHighestOddsData(statistics === null || statistics === void 0 ? void 0 : statistics.highestOdds);
                if (underMaintenance) {
                    iframeService.reloadFrame();
                }
            },
            _b[GameLiveConnectionMethod.GameOpen] = function (arg) { return applicationStore.checkGameIsOpen(arg, _this.connection); },
            _b["".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.RoundFinished)] = function (arg) {
                betStore.updateCurrentWinnersWithDelay(arg.bets);
            },
            _b["".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.GetInitialStateResult)] = function (arg) {
                var currentWinners = arg.currentWinners, sliderBanners = arg.sliderBanners, hasDemo = arg.hasDemo;
                lobbyStore.setHasDemo(hasDemo);
                betStore.setCurrentWinners(currentWinners);
                if (sliderBanners) {
                    lobbyStore.setSliderBanners(sliderBanners);
                }
            },
            _b["".concat(ConnectionPrefix.Game, "_").concat(GameLiveConnectionMethod.GetInitialStateResult)] = function (arg) {
                if (!gameConfigStore.gameTypeId) {
                    gameConfigStore.setGameTypeId(arg);
                }
            },
            _b);
        methods[methodName](data);
    };
    return BaseLiveConnection;
}());

var GameLiveConnection = /** @class */ (function (_super) {
    __extends(GameLiveConnection, _super);
    function GameLiveConnection(_a) {
        var url = _a.url;
        return _super.call(this, url) || this;
    }
    GameLiveConnection.prototype.sendGetInitialState = function (getInitialParams) {
        return this.invoke(GameLiveConnectionMethod.GetInitialState, getInitialParams);
    };
    GameLiveConnection.prototype.ping = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.connection) {
            return (_a = this.connection).invoke.apply(_a, __spreadArray([GameLiveConnectionMethod.Ping], __read(args), false));
        }
    };
    GameLiveConnection.prototype.doBet = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.connection) {
            return (_a = this.connection).invoke.apply(_a, __spreadArray([GameLiveConnectionMethod.DoBet], __read(args), false));
        }
    };
    GameLiveConnection.prototype.onGetInitialStateResult = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.GetInitialStateResult, function (data) {
            if (callback) {
                callback(data);
            }
            var gameTypeId = data.gameTypeId;
            if (gameTypeId) {
                _this.callbackMiddleware({
                    methodName: "".concat(ConnectionPrefix.Game, "_").concat(GameLiveConnectionMethod.GetInitialStateResult),
                    data: gameTypeId,
                });
            }
        });
    };
    GameLiveConnection.prototype.onDoBetResult = function (callback) {
        return this.on(GameLiveConnectionMethod.DoBetResult, callback);
    };
    GameLiveConnection.prototype.onDoBetResultValidation = function (callback) {
        return this.on(GameLiveConnectionMethod.DoBetResultValidation, callback);
    };
    GameLiveConnection.prototype.onRoundFinished = function (callback) {
        return this.on(GameLiveConnectionMethod.RoundFinished, callback);
    };
    GameLiveConnection.prototype.onRoundStarted = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.RoundStarted, function (data) {
            if (callback) {
                callback(data);
            }
            var _a = data.data, underMaintenance = _a.underMaintenance, statistics = _a.statistics;
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.RoundStarted,
                data: { underMaintenance: underMaintenance, statistics: statistics },
            });
        });
    };
    GameLiveConnection.prototype.onResultReport = function (callback) {
        return this.on(GameLiveConnectionMethod.ResultReport, callback);
    };
    GameLiveConnection.prototype.onMaintenanceNotify = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.MaintenanceNotify, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.UnderMaintenance,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onBalanceUpdate = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.BalanceUpdate, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.BalanceUpdate,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onPing = function (callback) {
        return this.on(GameLiveConnectionMethod.Ping, callback);
    };
    GameLiveConnection.prototype.onBetsClosed = function (callback) {
        return this.on(GameLiveConnectionMethod.BetsClosed, callback);
    };
    GameLiveConnection.prototype.onUserTournamentInfo = function (callback) {
        return this.on(GameLiveConnectionMethod.UserTournamentInfo, callback);
    };
    GameLiveConnection.prototype.onGameOpen = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.GameOpen, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.GameOpen,
                data: data,
            });
        });
    };
    return GameLiveConnection;
}(BaseLiveConnection));

var LobbyLiveConnection = /** @class */ (function (_super) {
    __extends(LobbyLiveConnection, _super);
    function LobbyLiveConnection(_a) {
        var url = _a.url;
        return _super.call(this, url) || this;
    }
    LobbyLiveConnection.prototype.sendGetInitialState = function (partnerId) {
        return this.invoke(LobbyLiveConnectionMethod.GetInitialState, {
            partnerId: partnerId,
        });
    };
    LobbyLiveConnection.prototype.onGetInitialStateResult = function (callback) {
        var _this = this;
        return this.on(LobbyLiveConnectionMethod.GetInitialStateResult, function (data) {
            if (callback) {
                callback(data);
            }
            var underMaintenance = data.underMaintenance, currentWinners = data.currentWinners, sliderBanners = data.sliderBanners, hasDemo = data.hasDemo;
            if (underMaintenance) {
                _this.callbackMiddleware({
                    methodName: CommonConnectionsMethod.UnderMaintenance,
                    data: underMaintenance,
                });
            }
            _this.callbackMiddleware({
                methodName: "".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.GetInitialStateResult),
                data: {
                    sliderBanners: sliderBanners,
                    currentWinners: currentWinners,
                    hasDemo: hasDemo,
                },
            });
        });
    };
    LobbyLiveConnection.prototype.onRoundFinished = function (callback) {
        var _this = this;
        return this.on(LobbyLiveConnectionMethod.RoundFinished, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: "".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.RoundFinished),
                data: data,
            });
        });
    };
    LobbyLiveConnection.prototype.onLobbyUsersCount = function (callback) {
        return this.on(LobbyLiveConnectionMethod.LobbyUsersCount, callback);
    };
    LobbyLiveConnection.prototype.onMaintenanceNotify = function (callback) {
        var _this = this;
        return this.on(LobbyLiveConnectionMethod.MaintenanceNotify, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.UnderMaintenance,
                data: data,
            });
        });
    };
    return LobbyLiveConnection;
}(BaseLiveConnection));

var TranslationService = /** @class */ (function () {
    function TranslationService(_a) {
        var url = _a.url;
        this.url = url;
    }
    TranslationService.prototype.getTranslations = function (request) {
        var applicationId = request.applicationId, params = __rest(request, ["applicationId"]);
        return httpClient.get(this.url, {
            params: params,
            headers: { applicationId: applicationId },
        });
    };
    return TranslationService;
}());

export { ApplicationStore as A, BaseLiveConnection as B, ChatService as C, GameLiveConnection as G, IframeService as I, LobbyLiveConnection as L, PostMessage as P, RoundsService as R, StatisticsService as S, TranslationService as T, UsersService as U, PostMessageListenerMessages as a, BetsService as b, chatService as c, betStore as d, BetsStore as e, PopupStore as f, UserInfoStore as g, httpClient as h, iframeService as i, statisticsStore as j, StatisticsStore as k, applicationStore as l, TableBetHistoryStore as m, profileAvatarStore as n, ProfileAvatarStore as o, popupStore as p, setHttpClientInterceptors as s, tableBetHistoryStore as t, userInfoStore as u };
